import { render, staticRenderFns } from "./SocioUsuarioInfo.vue?vue&type=template&id=0def7e82&scoped=true&"
import script from "./index.js?vue&type=script&lang=js&"
export * from "./index.js?vue&type=script&lang=js&"
import style0 from "./style.sass?vue&type=style&index=0&id=0def7e82&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0def7e82",
  null
  
)

export default component.exports